
import React from "react";
import "./VirasatDefaultHomePage.scss"
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const VirsatDefaultStoryPage = ({ components }) => {
    const dispatch = useDispatch()

    const getLeftComponent = (component) => {
        switch (component.ID) {
            case "VirsatDefaultStoryPage-since":
                return <div className="since-text-story">- {component?.Props?.text} -</div>

            case "VirsatDefaultStoryPage-header":
                return <div className="VirsatDefaultStoryPage-container-title">{component?.Props?.header}
                    <div className="VirsatDefaultStoryPage-container-title-story">{component?.Props?.highlightedHeader}</div></div>

            case "VirsatDefaultStoryPage-paragraph":
                return component?.Data?.map((text, key) => {
                    return (
                        <div className="VirsatDefaultStoryPage-container-text-cont" key={key}>
                            {text?.text}
                        </div>
                    )
                })
            case "VirsatDefaultStoryPage-button":
                return <div className="VirsatDefaultStoryPage-btn-cont">
                    <Button
                        text={component?.Props?.text}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                if (component?.Props?.href?.includes("https://")) {
                                    window.open(component?.Props?.href, '_blank')
                                } else {
                                    window.location.href = component?.Props?.href && component?.Props?.href !== "" ? component?.Props?.href : "/"
                                }
                            }
                            else {
                                dispatch(setIsComing(true))
                            }
                        }}
                    />
                </div>
            default:
                return <div />
        }
    }
    const leftContent = (leftComponents) => {
        return (
            <div className="VirsatDefaultStoryPage-container-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return (
                        getLeftComponent(component)
                    )
                })}

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirsatDefaultStoryPage-left":
                return leftContent(component?.Components)
            case "VirsatDefaultStoryPage-icon":
                return <div className="VirsatDefaultStoryPage-container-icon">
                    <div className="VirsatDefaultStoryPage-container-icon-inner">
                        <img alt="" src={component?.Props?.icon} />
                    </div>

                </div>
            case "VirsatDefaultStoryPage-right":
                return <div className="VirsatDefaultStoryPage-container-right"
                    style={{ backgroundImage: `url(${component?.Props?.src})` }}>
                    <div className="VirsatDefaultStoryPage-container-right-inner" />
                </div>
            default:
                return <div />
        }

    }

    return (
        <div className="VirsatDefaultStoryPage" >
            <div className="VirsatDefaultStoryPage-container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getComponents(component)
                    )
                })}
            </div>
        </div>
    )
}
export default VirsatDefaultStoryPage